import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import MoflipLogo from './MoflipLogo'
import { APP_VERSION, BUILD_YEAR } from '../constants/version'

function LoginCard({
  username,
  setUsername,
  password,
  setPassword,
  handleLogin,
  isLoading,
}) {
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = (event) => {
    event.preventDefault()
    handleLogin()
  }

  return (
    <div className="w-full max-w-[420px] mx-auto flex flex-col">
      <div className="flex justify-center mb-8">
        <MoflipLogo />
      </div>

      <h1 className="text-3xl font-bold text-center text-[#191a1a]">
        Selamat Datang Kembali!
      </h1>
      <p className="mt-2 text-center text-sm text-[#696A6B]">
        Masuk untuk melanjutkan pengelolaan data keanggotaan.
      </p>

      <form onSubmit={handleSubmit} className="mt-8">
        <div className="mb-5">
          <label
            htmlFor="username"
            className="block mb-2 text-sm font-semibold text-[#191a1a]"
          >
            Username
          </label>
          <input
            type="text"
            id="username"
            autoComplete="username"
            placeholder="Masukkan username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            className="w-full h-12 px-4 rounded-lg border border-[#E3E6E8] bg-[#F9FAFB] text-sm outline-none transition-colors focus:border-[#f3790e] focus:bg-white"
          />
        </div>

        <div className="mb-6">
          <label
            htmlFor="password"
            className="block mb-2 text-sm font-semibold text-[#191a1a]"
          >
            Kata Sandi
          </label>
          <div className="flex items-center gap-2 h-12 px-4 rounded-lg border border-[#E3E6E8] bg-[#F9FAFB] transition-colors focus-within:border-[#f3790e] focus-within:bg-white">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              placeholder="Masukkan kata sandi"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="grow bg-transparent text-sm outline-none"
            />
            <button
              type="button"
              onClick={() => setShowPassword((shown) => !shown)}
              aria-label={
                showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'
              }
              className="text-[#838489] hover:text-[#191a1a] transition-colors"
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full h-12 rounded-lg bg-[#f3790e] text-white text-sm font-semibold transition-opacity hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Memproses...' : 'Masuk'}
        </button>
      </form>

      <p className="mt-8 text-center text-xs leading-relaxed text-[#696A6B]">
        Dengan masuk, Anda menyetujui{' '}
        <Link to="/syarat-ketentuan" className="underline hover:text-[#f3790e]">
          Syarat &amp; Ketentuan
        </Link>{' '}
        dan menyatakan telah membaca{' '}
        <Link to="/kebijakan-privasi" className="underline hover:text-[#f3790e]">
          Kebijakan Privasi
        </Link>
        .
      </p>

      <p className="mt-6 text-center text-xs text-[#838489]">
        Versi {APP_VERSION} &middot; Dibangun {BUILD_YEAR}
      </p>
    </div>
  )
}

export default LoginCard
